export default async function UpdateWorkOrder(sendForm) {
    let url = window.RealestateService+  `/api/WorkOrder/UpdateWorkOrder`
    let head = {
         "content-type":"application/json",
        "accept":"*/*",
        "Authorization":window.token
    }
    let response = await fetch(url, {
        method:"PUT",
        headers:head,
        body:JSON.stringify(sendForm)
    }).then(res=>res.json()).catch(res=>res)

    return response
}